import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'

interface LineChartProps {
    title: string;
    data: {
        series: { name: string; data: number[] }[];
        name?: string;
        categories: string[];
        si_unit: string;
    };
    height?: number;
    width?: number;
    size?: number;
}

const EnergyLineChart = ({ title, data, height, width, size = 6 }: LineChartProps) => {
    var lineChart: ApexOptions = {
        chart: {
            height: height ?? 350,
            type: 'line',
            toolbar: {
                show: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight',
            width: 3
        },
        series: data.series,
        xaxis: {
            categories: data.categories,
        },
        yaxis: {
            title: {
                text: data.si_unit
            }
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (val) {
                    return `${val} ${data.si_unit}`
                }
            }
        },
        colors: ['#e9622c','#308e87', '#f39159', '#51bb25'],
        legend: {
            show: true,
            labels: {
                colors: '#ffffff'
            }
        },
    }
    return (
        <Col sm={12} xl={size} className={`box-col-${size}`}>
            <Card style={{ width: '100%' }}>
                {/* <CommonCardHeader title={title} /> */}
                <CardBody>
                    <div id="line-chart" style={{ width: '100%' }}>
                        <ReactApexChart options={lineChart} series={lineChart.series} type="line" height={height ?? 350} width={width ?? 400}/>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}

export default EnergyLineChart;
